import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets scroll to the top whenever the route changes. Mounted once at
// the router root (AppRoot). Hash-link navigations are skipped so that
// fragment anchors keep working — the browser's default behavior takes
// over once we no-op.
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
